import React, { useEffect } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";

import { useGeneralContext } from "./context/GeneralContext";
import Datalayer from "./services/datalayer";

import CourseDetails from "./pages/CourseDetails";
import AppExplore from "./pages/AppExplore/Index";
import ProfessorDetails from "./pages/ProfessorDetails";
import Account from "./pages/Account";
import CategoryDetails from "./pages/CategoryDetails";
import Professors from "./pages/Professors";
import Popular from "./pages/Popular";
import CategoriesList from "./pages/CategoriesList";
import Login from "./pages/Login";
import LoginPassword from "./pages/LoginPassword";
import LoginMessage from "./pages/LoginMessage";
import ChangePassword from "./pages/ChangePassword";
import NewPassword from "./pages/NewPassword";
import Error404 from "./pages/Error404";
import RedirectToOndemand from "./components/RedirectToOndemand";
import RedirectToWebsite from "./components/RedirectToWebsite";
// import SignupFreeAccount from "./pages/SignupFreeAccount";
// import Anniversary from "./pages/Anniversary";

const Routes = () => {
  const location = useLocation();
  const { user } = useGeneralContext();
  const { id: userId } = user;

  useEffect(() => {
    Datalayer.onPageLoad(userId);
  }, [location, userId]);

  return (
    <Switch>
      <Route path="/explore" exact component={RedirectToWebsite} />
      <Route path="/signup" exact component={RedirectToOndemand} />
      <Route path="/subscribe" exact component={RedirectToOndemand} />
      <Route
        path="/explore/cadastro"
        exact
        component={() => {
          // CAMPANHA
          // cadastro desativado e direcionando para o site casadosaber.com.br
          window.location.href = "https://casadosaber.com.br";
        }}
      />
      <Route path="/menu-categorias" exact component={CategoriesList} />
      <Route path="/minha-conta" exact component={Account} />
      <Route path="/populares" exact component={Popular} />
      <Route path="/professor/:id" exact component={ProfessorDetails} />
      <Route path="/categoria/:id" exact component={CategoryDetails} />
      <Route path="/professores" exact component={Professors} />
      <Route path="/explore/entrar" exact component={Login} />
      <Route path="/explore/entrar/info" exact component={LoginMessage} />
      <Route path="/explore/entrar/senha" exact component={LoginPassword} />
      <Route path="/nova-senha" exact component={NewPassword} />
      <Route path="/alterar-senha" exact component={ChangePassword} />
      {/* CAMPANHA */}
      <Route
        path="/cursos-gratuitos-de-aniversario"
        exact
        component={() => {
          // CAMPANHA
          // direcionando para LP de aniversário
          window.location.href = "https://lp.casadosaber.com.br/aniversario";
        }}
      />
      <Route path="/:slug" exact component={CourseDetails} />
      <Route path="*" exact component={Error404} />
    </Switch>
  );
};

export default Routes;
